const WRETCH_REQUEST_METHODS = ['url', 'get', 'post', 'put', 'delete', 'json'];

const isHandledBySportsApi = response =>
    Boolean(
        response &&
            typeof response === 'object' &&
            WRETCH_REQUEST_METHODS.every(
                method => typeof response[method] === 'function',
            ),
    );

export default isHandledBySportsApi;
